export default "__VITE_ASSET__C$qwRIeO__"